/**
 * Deployment configuration helper
 *
 * Legacy components still expect a static export, so we provide
 * getter-backed properties that read from the runtime configuration
 * service. This keeps everything aligned with the /api/config response
 * even when the build is reused across environments.
 */

import runtimeConfigService from './config/runtimeConfig';

const getRuntimeEnvironment = () => {
  try {
    return runtimeConfigService.toEnvironmentConfig();
  } catch {
    return null;
  }
};

export const deploymentConfig = {
  get mode(): 'container' | 'functions' {
    return 'container';
  },
  get apiUrl(): string {
    return getRuntimeEnvironment()?.apiUrl || '';
  },
  get authEnabled(): boolean {
    return true;
  },
  get environment(): 'local-test' | 'development' | 'production' {
    const env = getRuntimeEnvironment();
    if (env?.name === 'production') {
      return 'production';
    }
    return 'development';
  }
};

export default deploymentConfig;
